import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import IconLetters from '../icons/IconLetters.jsx'
import meta from './metaRef.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canWriteTree(map, node) {
            return false
        },

        getIcons(map, node) {
            return [
                <IconLetters
                    key="type"
                    fill={Color.BLUE}
                    letters="R"
                    textColor="#fff"
                />
            ]
        },

        getStyle(map, node) {
            return {
                ...CategoryNode.getStyle.call(this, map, node),
                borderColor: Color.CYAN,
            }
        },
    })
}
